export const quote = {
  quote: {
    confirmDialog: {
      name: "Nombre:",
      description: "Descripción:",
      validity: "Esta cotización es válida hasta {{ expirationTime }}",
      option: {
        yes: "Sí",
        no: "No"
      },
      buyer: {
        submit: {
          a11y: {
            close: "Cerrar modal de envío de cotización"
          },
          title: "¿Enviar Solicitud de Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas enviar esta solicitud de cotización?",
          successMessage: "Solicitud de cotización enviada con éxito"
        },
        cancel: {
          a11y: {
            close: "Cerrar modal de cancelación de cotización"
          },
          title: "¿Cancelar Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas cancelar esta cotización?",
          successMessage: "La cotización ha sido cancelada"
        }
      },
      buyer_offer: {
        edit: {
          a11y: {
            close: "Cerrar modal de edición de cotización"
          },
          title: "¿Confirmar Edición de Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas editar esta cotización aprobada?",
          warningNote: "Esta cotización ha sido aprobada. Editar esta cotización evitará el checkout hasta que las nuevas ediciones sean aprobadas."
        },
        cancel: {
          a11y: {
            close: "Cerrar modal de cancelación de cotización"
          },
          title: "¿Cancelar Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas cancelar esta cotización?",
          successMessage: "Cotización cancelada"
        },
        checkout: {
          a11y: {
            close: "Cerrar modal de checkout de cotización"
          },
          title: "¿Checkout de Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas aceptar y realizar el checkout de esta cotización?"
        }
      },
      expired: {
        edit: {
          a11y: {
            close: "Cerrar modal de edición de cotización"
          },
          title: "¿Confirmar Edición de Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas editar esta cotización vencida?",
          warningNote: "Esta cotización está vencida. Editar esta cotización evitará el checkout hasta que las nuevas ediciones sean aprobadas."
        },
        requote: {
          a11y: {
            close: "Cerrar modal de recreación de cotización"
          },
          title: "¿Recrear Solicitud de Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas recrear esta solicitud de cotización?",
          warningNote: "Esta cotización está vencida. Recrearla generará una nueva solicitud de cotización con el mismo contenido, que podrá ser editada y enviada para aprobación posteriormente."
        }
      },
      seller: {
        submit: {
          a11y: {
            close: "Cerrar modal de envío de cotización"
          },
          title: "¿Enviar Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas enviar esta cotización?",
          warningNote: "Dependiendo del valor total de la cotización, podría ser necesaria una aprobación adicional antes de que el comprador pueda realizar el checkout de esta cotización.",
          successMessage: "Cotización enviada con éxito"
        }
      },
      sellerapprover: {
        approve: {
          a11y: {
            close: "Cerrar modal de aprobación de cotización"
          },
          title: "¿Aprobar Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas aprobar esta cotización?",
          successMessage: "Cotización aprobada con éxito"
        },
        reject: {
          a11y: {
            close: "Cerrar modal de rechazo de cotización"
          },
          title: "¿Rechazar Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas rechazar esta cotización?",
          successMessage: "Cotización rechazada"
        }
      },
      cancelled: {
        requote: {
          a11y: {
            close: "Cerrar modal de recreación de cotización"
          },
          title: "¿Recrear Solicitud de Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas recrear esta solicitud de cotización?",
          warningNote: "Tu carrito actual será convertido en un carrito guardado."
        }
      },
      all: {
        edit: {
          a11y: {
            close: "Cerrar modal de edición de cotización"
          },
          title: "¿Editar Cotización {{ code }}?",
          confirmNote: "¿Estás seguro de que deseas editar esta cotización?",
          warningNote: "Tu carrito actual será convertido en un carrito guardado."
        }
      }
    },
    comments: {
      regionTitle: "Caja de contacto/comentarios",
      title: "Contacto",
      invalidComment: "Entrada no válida - Por favor, inténtelo de nuevo...",
      allProducts: "Todos los productos"
    },
    commons: {
      requestQuote: "Solicitar cotización",
      cart: "Carrito",
      minRequestInitiationNote: "Se requiere un subtotal mínimo de ${{minValue}} para enviar una cotización",
      minRequestWeightNote: "Para solicitar una cotización el peso total debe ser mínimo {{ weight }} Kg",
      savedActiveCart: "Su carrito activo se convirtió en el carrito guardado {{ code }}",
      contractProductsInCartNote : "No es possible solicitar cotizaciones para productos promocionales:"
    },
    header: {
      buyerEdit: {
        a11y: {
          cancel: "Cancelar la edición de la información del encabezado de la cotización",
          save: "Guardar la información del encabezado de la cotización"
        }
      },
      overview: {
        regionTitle: "Resumen de detalles de la cotización",
        id: "ID de la cotización",
        status: "Estado",
        information: "Información de la cotización",
        name: "Nombre",
        description: "Descripción",
        charactersLeft: "caracteres restantes: {{count}}",
        priceAndExpiry: "Precio y vencimiento",
        estimatedTotal: "Total estimado",
        total: "Total",
        expirationTime: "Fecha de vencimiento",
        a11y: {
          edit: "Editar la información del encabezado de la cotización"
        },
        createdAndUpdated: "Creado y actualizado",
        createdDate: "Creado",
        lastUpdatedDate: "Última actualización"
      }
    },
    httpHandlers: {
      cartValidationIssue: "Hay problemas con sus entradas. Por favor revise su carrito.",
      quoteCartIssue: "No es posible realizar cambios en las entradas del carrito. Proceda al pago",
      absoluteDiscountIssue: "Elija un descuento que no exceda el valor total",
      expirationDateIssue: "Elija una fecha de vencimiento en el futuro",
      threshold: {
        underThresholdError: "El precio total de la cotización solicitada no cumple con el umbral mínimo"
      },
      expired: "Esta cotización ha caducado. Debe enviar nuevamente su solicitud de cotización para recibir otra oferta del proveedor.",
      downloadPDFError: "Algo salió mal. No se pudo obtener el documento PDF de la propuesta."
    },
    items: {
      regionTitle: "Artículos del carrito"
    },
    links: {
      newCart: "Nuevo carrito",
      quotes: "Cotizaciones",
      download: "Descargar propuesta",
      a11y: {
        newCart: "Crear un nuevo carrito vacío y navegar hacia él.",
        quotes: "Navegar a la lista de resultados de búsqueda de cotizaciones.",
        download: "Iniciar la descarga de una propuesta de cotización"
      }
    },
    list: {
      regionTitle: "Resumen de la lista de cotizaciones",
      title: "Lista de cotizaciones",
      name: "Nombre",
      updated: "Actualizado",
      sortBy: "Ordenar por",
      sortQuotes: "Ordenar cotizaciones",
      empty: "No tenemos registros de cotizaciones para esta cuenta.",
      quoteId: "ID de la cotización",
      status: "Estado",
      clickableRow: "Haga clic en la fila para más detalles de la cotización"
    },
    states: {
      BUYER_DRAFT: "Borrador",
      BUYER_SUBMITTED: "Enviado",
      BUYER_ACCEPTED: "Aceptado",
      BUYER_APPROVED: "Aprobado",
      BUYER_REJECTED: "Rechazado",
      BUYER_OFFER: "Cotización del proveedor",
      BUYER_ORDERED: "Pedido",
      SELLER_DRAFT: "Borrador",
      SELLER_REQUEST: "Solicitado",
      SELLER_SUBMITTED: "Enviado",
      SELLERAPPROVER_DRAFT: "Borrador",
      SELLERAPPROVER_PENDING: "Pendiente de aprobación",
      SELLERAPPROVER_APPROVED: "Aprobado",
      SELLERAPPROVER_REJECTED: "Rechazado",
      CREATED: "Creado",
      CANCELLED: "Cancelado",
      EXPIRED: "Caducado"
    },
    summary: {
      regionTitle: "Resumen del pedido",
      actions: {
        APPROVE: "Aprobar cotización",
        CANCEL: "Cancelar cotización",
        CHECKOUT: "Aceptar y pagar",
        EDIT: "Editar cotización",
        REJECT: "Rechazar cotización",
        REQUOTE: "Solicitar nueva cotización",
        SAVE: "Guardar cotización",
        SUBMIT: "Enviar cotización",
        VIEW: "Ver cotización"
      },
      prices: {
        title: "Resumen del pedido",
        subtotal: "Subtotal",
        productDiscount: "Descuento en artículos",
        orderDiscount: "Descuento en el pedido",
        quoteDiscount: "Descuento de cotización",
        total: "Total",
        hint: "No se incluyen impuestos en el total"
      },
      sellerEdit: {
        discount: "Descuento",
        apply: "Aplicar",
        expiryDate: "Fecha de vencimiento",
        discountValidationText: "Ingrese un porcentaje de descuento válido",
        a11y: {
          apply: "Haga clic para aplicar el valor de descuento ingresado a esta cotización",
          discount: "Ingrese un porcentaje de descuento para aplicar a esta cotización",
          expiryDate: "Ingrese una fecha de vencimiento para esta cotización"
        }
      }
    }
  }
}
